var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortalLogoCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 42,
    viewBox: "0 0 160 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3180_1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2115 8.43053L99.8073 9.37768H119.55C119.422 8.93143 119.266 8.48517 119.101 8.05713H82.8877V9.37768H98.6158L99.2115 8.43053Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.49 2.78369H82.8877V4.10424H116.754C116.36 3.63977 115.939 3.20263 115.49 2.78369Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.726 5.42529H82.8877V6.74585H118.496C118.258 6.29048 118.01 5.85333 117.726 5.42529Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4821 15.9805H82.8877V17.301H93.648L94.4821 15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1319 13.3398H82.8877V14.6604H95.307L96.1319 13.3398Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 10.6982H120.136V12.0188H134.096V10.6982Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.548 0.143066H82.8877V1.46362H113.867C113.143 0.953613 112.364 0.516464 111.548 0.143066Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7901 0.143066H53.0172L52.6047 1.46362H70.2209L69.7901 0.143066Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 8.05713H120.136V9.37768H134.096V8.05713Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 5.42529H120.136V6.74585H134.096V5.42529Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.116 14.6604H120.081C120.118 14.2597 120.146 13.859 120.146 13.4582V14.6604H134.105V13.3398H120.146V13.4582C120.146 13.4582 120.146 13.3854 120.146 13.3398H102.3L103.125 14.6604H103.116Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.457 12.0188H120.063C120.017 11.5725 119.953 11.1354 119.871 10.6982H100.632L101.457 12.0188Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 39.7324H0.883789V41.053H14.8429V39.7324Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 34.4497H0.883789V35.7703H14.8429V34.4497Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 37.0908H0.883789V38.4114H14.8429V37.0908Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 31.8091H0.883789V33.1296H14.8429V31.8091Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6517 2.78369H52.2015L51.7891 4.10424H71.0734L70.6517 2.78369Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 29.1768H0.883789V30.4973H14.8429V29.1768Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3565 8.05713H50.5609L50.1484 9.37768H72.7873L72.3565 8.05713Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9227 15.9805H48.0952L47.6919 17.301H75.3443L74.9227 15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5041 5.42529H51.3766L50.9641 6.73674H71.9257L71.5041 5.42529Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.209 10.6982H49.736L49.3328 12.0188H73.6398L73.209 10.6982Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0616 13.3398H48.9205L48.5081 14.6604H74.4924L74.0616 13.3398Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 2.78369H120.136V4.10424H134.096V2.78369Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 29.1768H145.782V30.4973H159.741V29.1768Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 26.5356H145.782V27.8562H159.741V26.5356Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 23.895H145.782V25.2156H159.741V23.895Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 21.2534H120.136V22.574H145.754L145.782 22.5193V22.574H159.741V21.2534Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.136 25.2156H144.196L144.975 23.895H120.136V25.2156Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.512 19.9329H118.606C118.817 19.5048 119.009 19.0677 119.183 18.6123H101.512V19.9329Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.136 27.8562H142.638L143.417 26.5356H120.136V27.8562Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.908 15.9805H103.941L104.812 17.3648L119.614 17.301C119.733 16.8639 119.834 16.4267 119.908 15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.512 22.0002V22.574H116.938C117.277 22.155 117.579 21.7088 117.873 21.2534H101.521V22.0002H101.512Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.512 27.8562H108.029C109.44 27.6103 110.788 27.1549 112.034 26.5356H101.512V27.8562Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.512 25.2156H114.179C114.729 24.8057 115.251 24.3777 115.746 23.895H101.512V25.2156Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 0.143066H145.012L144.233 1.46362H159.741V0.143066Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.136 30.4973H141.089L141.868 29.1768H120.136V30.4973Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 13.3398H137.24L136.46 14.6604H159.741V13.3398Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 15.9805H120.136V17.301H134.096V15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 10.6982H138.788L138.009 12.0188H159.741V10.6982Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 0.143066H120.136V1.46362H134.096V0.143066Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.096 18.6216H120.136V19.933H159.741V18.6216H134.123L134.096 18.6762V18.6216Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 8.05713H140.346L139.567 9.37768H159.741V8.05713Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 2.78369H143.454L142.675 4.10424H159.741V2.78369Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 26.5356H0.883789V27.8562H14.8429V26.5356Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 5.42529H141.896L141.126 6.73674H159.741V5.42529Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.741 15.9805H135.681L134.902 17.301H159.741V15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4802 23.895H62.907L63.3653 25.2156H77.911L77.4802 23.895Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3327 26.5356H63.8145L64.2727 27.8562H78.7634L78.3327 26.5356Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.899 34.4497H66.5366L66.9949 35.7703H81.3298L80.899 34.4497Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0465 31.8091H65.6292L66.0874 33.1296H80.4682L80.0465 31.8091Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6277 21.2534H61.9995L62.4578 22.574H77.0585L76.6277 21.2534Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1941 29.1768H64.7217L65.18 30.4973H79.6157L79.1941 29.1768Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5859 30.4973H57.9575L58.3425 29.1768H43.9984L43.5859 30.4973Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4109 27.8562H58.7366L59.1216 26.5356H44.8233L44.4109 27.8562Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7753 18.6216H47.2796L46.8672 19.933H61.0738L61.2938 19.1953L61.5504 19.933H76.1969L75.7753 18.6216Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2266 25.2156H59.5156L59.9006 23.895H45.639L45.2266 25.2156Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7703 33.1296H57.1785L57.5634 31.8091H43.1827L42.7703 33.1296Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0515 22.574H60.2948L60.6797 21.2534H46.4548L46.0515 22.574Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 23.895H82.8877V25.2156H96.8468V23.895Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 21.2534H82.8877V22.574H96.8468V21.2534Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8877 12.0188H96.9568L97.7909 10.6982H82.8877V12.0188Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 18.6216H82.8877V19.9421H96.8468V18.6216Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7514 37.0908H67.4531L67.9022 38.4114H82.1821L81.7514 37.0908Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 26.5356H82.8877V27.8562H96.8468V26.5356Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8877 40.5976L82.6036 39.7324H68.3604L68.8095 41.053H96.8468V39.7324H82.8877V40.5976Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 37.0908H82.8877V38.4114H96.8468V37.0908Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 31.8091H82.8877V33.1296H96.8468V31.8091Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 34.4497H82.8877V35.7703H96.8468V34.4497Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8468 29.1768H82.8877V30.4973H96.8468V29.1768Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 15.9805H25.9424V17.301H39.9015V15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 23.895H25.9424V25.2156H39.9015V23.895Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9546 35.7703H56.3995L56.7844 34.4497H42.3579L41.9546 35.7703Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 37.0908H25.9424V38.4114H39.9015V37.0908Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 29.1768H25.9424V30.4973H39.9015V29.1768Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 26.5356H25.9424V27.8562H39.9015V26.5356Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 34.4497H25.9424V35.7703H39.9015V34.4497Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 21.2534H0.883789V22.574H14.8429V21.2534Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 18.6216H0.883789V19.9421H14.8429V18.6216Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 15.9805H0.883789V17.301H14.8429V15.9805Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 39.7324H25.9424V41.053H39.9015V39.7324Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 13.3398H0.883789V14.6604H14.8429V13.3398Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 31.8091H25.9424V33.1296H39.9015V31.8091Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 2.78369H0.883789V4.10424H39.9015V2.78369Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 5.42529H0.883789V6.74585H39.9015V5.42529Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 0.143066H0.883789V1.46362H39.9015V0.143066Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 21.2534H25.9424V22.574H39.9015V21.2534Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3137 41.053H54.8411L55.2352 39.7324H40.717L40.3137 41.053Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1294 38.4114H55.6201L56.0142 37.0908H41.5418L41.1294 38.4114Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 18.6216H25.9424V19.9421H39.9015V18.6216Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8429 23.895H0.883789V25.2156H14.8429V23.895Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.883789 8.43053V9.37768H39.9015V8.43053V8.05713H0.883789V8.43053Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 13.3398H25.9424V14.6604H39.9015V13.3398Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 10.6982H0.883789V12.0188H39.9015V10.6982Z",
    fill: "#EAE406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.003 38.8578C153.82 39.4133 153.948 39.7138 154.461 39.7138H154.755V41.1073H151.382V39.7138H151.528C151.712 39.7138 151.877 39.5681 151.959 39.3678L153.527 34.9507C153.572 34.8232 153.472 34.6502 153.325 34.6502H152.949V33.2021H157.229L159.218 39.4588C159.264 39.5863 159.448 39.7229 159.557 39.7229H159.741V41.1164H155.699V39.7229H156.588L155.268 35.1693H155.25L154.012 38.8578",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.052 39.7142C150.942 39.7142 150.758 39.5775 150.713 39.45L148.724 33.1934H144.443V34.6414H144.819C144.966 34.6414 145.067 34.8236 145.021 34.942L143.453 39.359C143.371 39.5593 143.206 39.705 143.023 39.705H142.876V41.0985H146.249V39.705H145.956C145.397 39.705 145.332 39.3681 145.543 38.6759H147.78L148.073 39.705H147.184V41.0985H151.226V39.705H151.042L151.052 39.7142ZM145.937 37.4829L146.735 35.1605H146.753L147.422 37.4829H145.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.679 39.7138H138.055C138.193 39.7138 138.376 39.5135 138.376 39.386V34.714H137.744L137.569 36.1711H135.993V33.2021H143.426V36.1711H141.859L141.676 34.714H141.043V39.386C141.043 39.5135 141.226 39.7138 141.364 39.7138H141.74V41.1073H137.698V39.7138H137.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.286 39.7142H127.616C127.753 39.7142 127.936 39.5138 127.936 39.3863V34.9602C127.936 34.8327 127.744 34.6414 127.616 34.6414H127.286V33.1934H131.263V34.6414H130.594V37.829H130.631L132.483 33.2025H135.81V34.6505H135.489C135.351 34.6505 135.168 34.8418 135.168 34.9693V39.3954C135.168 39.5229 135.351 39.7233 135.489 39.7233H135.81V41.1167H131.841V39.7233H132.51V36.4355H132.473L130.613 41.1076H127.286V39.7142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.579 39.7142H118.909C119.046 39.7142 119.229 39.5138 119.229 39.3863V34.9602C119.229 34.8327 119.046 34.6414 118.909 34.6414H118.579V33.1934H126.956V34.6414H126.626C126.488 34.6414 126.305 34.8327 126.305 34.9602V39.3863C126.305 39.5138 126.488 39.7142 126.626 39.7142H126.956V41.1076H122.996V39.7142H123.647V34.6596H121.887V39.7142H122.538V41.1076H118.588V39.7142H118.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.239 39.7142C118.129 39.7142 117.946 39.5775 117.9 39.45L115.911 33.1934H111.631V34.6414H112.007C112.153 34.6414 112.254 34.8236 112.208 34.942L110.641 39.359C110.559 39.5593 110.394 39.705 110.21 39.705H110.064V41.0985H113.437V39.705H113.143C112.584 39.705 112.52 39.3681 112.731 38.6759H114.967L115.261 39.705H114.372V41.0985H118.414V39.705H118.23L118.239 39.7142ZM113.125 37.4829L113.922 35.1605H113.941L114.61 37.4829H113.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.58 36.5264L109.385 39.4043C109.486 39.541 109.587 39.7049 109.761 39.7049H109.899V41.0983H106.681V39.8779L105.536 37.9927L105.013 38.4663V39.7049H105.646V41.0983H101.705V39.7049H102.035C102.172 39.7049 102.355 39.5045 102.355 39.377V34.9509C102.355 34.8234 102.172 34.6321 102.035 34.6321H101.705V33.1841H105.618V34.6321H105.013V36.654L106.489 35.2241C106.819 34.9236 106.718 34.6412 106.342 34.6412H106.159V33.1932H109.853V34.6412H109.706C109.514 34.6412 109.358 34.7687 109.12 35.0055L107.589 36.5264H107.58Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3180_1262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.857,
    height: 40.9554,
    fill: "white",
    transform: "translate(0.883789 0.143066)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalLogoCarousel);
export default __webpack_public_path__ + "static/media/portal_logo_carousel.bdfa37e654400b0eb3619d72d43537cf.svg";
export { ForwardRef as ReactComponent };